import type { CrossFlowExtensions } from '@atlassiansox/cross-flow-base-types';
import { type ProvisioningApiExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export type { ProvisioningApiExtensionsOptions } from './types';

export const provisioningApiExtensionsWhitelist: string[] = ['provisioningApiParams'];

export const createProvisioningApiExtensions = (
	options: ProvisioningApiExtensionsOptions,
): CrossFlowExtensions =>
	createProductExtensions<{
		provisioningApiParams: ProvisioningApiExtensionsOptions;
	}>(provisioningApiExtensionsWhitelist)({
		provisioningApiParams: options,
	});
